import React from "react"
import "../css/style.scss"
import Header from "./Header"
import Footer from "./Footer"
import Zendesk from "react-zendesk"

const Layout = function(props) {
  const ZENDESK_KEY = "07ca3d28-c9e2-4286-a53f-95286f2ea877"

  const setting = {
    color: {
      theme: "#000",
    },
    launcher: {
      chatLabel: {
        "en-US": "Need Help",
      },
    },
  }
  return (
    <React.Fragment>
      <div className="d-flex flex-column min-vh-100">
        <Header />
        <div className="main-body flex-fill">{props.children}</div>
        <Footer />
      </div>
      <Zendesk
        zendeskKey={ZENDESK_KEY}
        {...setting}
        onLoaded={() => console.log("is loaded")}
      />
    </React.Fragment>
  )
}

export default Layout
